export const TIMELINE_LABELS = {
  deepSpace: 0,
  howItWorks: 0.12,
  aiChat: 0.18,
  run: 0.56,
  break2d3d: 0.755,
  bridge: 0.875,
  blenderLanding: 0.967,
  blender: 0.9955,
  metaverse: 0.999,
  finalCta: 1,
} as const;

export type TimelineLabel = keyof typeof TIMELINE_LABELS;
